export const BOX_COUNT_BY_BREAKPOINT = [
  { minWidth: 1024, count: 4 },
  { minWidth: 768, count: 3 },
  { minWidth: 480, count: 2 },
  { minWidth: 0, count: 1 },
];
